import { Stack, Group } from "@mantine/core"
import { SubmitButton } from "../../../-components/Buttons"
import { showErrorNotification } from "../../../utils/form-submission-notifications"
import { Form } from "../../../-components/typed-form"
import { schemaResolver } from "@mantine/form"
import { useTranslation } from "react-i18next"
import { ChangePasswordFormInputs } from "../../app/-components/change-password-form-inputs"
import { usePasswordRuleValidationSchema } from "../../app/-components/use-password-rule-validation-scheme"
import { DefaultUserNameTextInput } from "../../../-components/default-username-text-input"

interface Props {
  token: string
  userId: number
  userName: string
  onSuccess: () => void
}

export function ChangePasswordWithTokenForm({
  token,
  userId,
  userName,
  onSuccess,
}: Props) {
  const { t } = useTranslation("app_server")

  const { schema } = usePasswordRuleValidationSchema()

  return (
    <Form
      url="/api/Authentication/SetPasswordByToken"
      transform={(v) => ({
        password: v.password,
        token: token!,
        userId,
      })}
      validate={schemaResolver(schema)}
      initialValues={{
        password: "",
        confirmPassword: "",
        token: token || "",
      }}
      options={{
        onError: (err) => showErrorNotification(err),
        onSuccess: onSuccess,
      }}
    >
      {(f, _) => (
        <>
          <Stack>
            <DefaultUserNameTextInput disabled readOnly value={userName} />
            <ChangePasswordFormInputs
              passwordInputProps={f.getInputProps(_.password._PATH_)}
              confirmPasswordInputProps={f.getInputProps(
                _.confirmPassword._PATH_
              )}
            />
          </Stack>

          <Group mt="xl">
            <SubmitButton>{t("ConfirmPassword")}</SubmitButton>
          </Group>
        </>
      )}
    </Form>
  )
}
